<!--<button *ngIf="isAuthorized$ | async" class="dropdown-item" (click)="$event.preventDefault();openSubscription(subscriptionModal);">-->
<!--  {{'context-menu.actions.subscribe.btn' | translate}}-->
<!--</button>-->

<!--<ng-template #subscriptionModal let-c="close" let-d="dismiss">-->
<!--  <ds-subscription-modal (close)="c('cancel')" [dso]="injectedContextMenuObject" [epersonId]="epersonId"></ds-subscription-modal>-->
<!--</ng-template>-->
